import React from 'react';

import { Segmented, Space, Typography } from 'antd';

import type { DashboardPeriod } from '../hooks/useDashboardStats';

type Props = {
  value: DashboardPeriod;
  onChange: (p: DashboardPeriod) => void;
};

const OPTIONS: { label: string; value: DashboardPeriod }[] = [
  { label: '24h', value: 'day' },
  { label: '7d', value: 'week' },
  { label: '30d', value: 'month' },
  { label: '90d', value: '3months' },
];

export const PeriodSelector = ({ value, onChange }: Props) => (
  <Space align="center">
    <Typography.Text strong>Period</Typography.Text>
    <Segmented
      options={OPTIONS}
      value={value}
      onChange={(v) => onChange(v as DashboardPeriod)}
    />
  </Space>
);
